import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const videos = [
  { title: 'What is Pontis', videoId: 'm5KvwOZTAOg' },
  { title: 'Monument Company Portal Walkthrough', videoId: 'Caf7CycB5vs' },
  { title: 'How to Create a Memorial with Families', videoId: 'xOZ-G1GJroQ' },
  { title: 'How to Explain Pontis to Families', videoId: 'vrhb_Kx-GoA' },
  { title: 'How to Install a Medallion (for Installation Teams)', videoId: 'h3z5mfu8Sfk' },
  { title: 'What Families Can Do Inside the Platform', videoId: 'TxlY2ZlKay8' },
];

const PortalTrainingVideos = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Training Videos</h1>
        <p className="text-muted-foreground mt-1">
          Learn how to use Pontis and get the most out of your portal.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {videos.map((video) => (
          <Card key={video.videoId}>
            <CardHeader className="pb-3">
              <CardTitle className="text-base">{video.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="aspect-video rounded-lg overflow-hidden">
                <iframe
                  src={`https://www.youtube.com/embed/${video.videoId}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PortalTrainingVideos;
